

async function updateCartSections() {
  try {
    const response = await fetch('/cart?section_id=cart-drawer');
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // // Update cart-drawer section
    // const cartDrawerHTML = doc.querySelector('#CartDrawer');
    // const cartDrawerElement = document.getElementById('CartDrawer');
    // if (cartDrawerElement && cartDrawerHTML) {
    //   cartDrawerElement.innerHTML = cartDrawerHTML.innerHTML;
    // }
// Update cart-drawer section
        const cartDrawerHTML = doc.querySelector('#CartDrawer-Form');
        console.log(cartDrawerHTML);
        const cartDrawerElement = document.getElementById('CartDrawer-Form');
        if (cartDrawerElement && cartDrawerHTML) {
          console.log("ui update called")
          cartDrawerElement.innerHTML = cartDrawerHTML.innerHTML;
        }
        const newCartIconBubble = doc.querySelector('.cart-count-bubble');
        console.log(newCartIconBubble);
        const currentCartIconBubble = document.querySelector('.cart-count-bubble');
        if (newCartIconBubble && currentCartIconBubble) {
          console.log("ui update called")
            currentCartIconBubble.innerHTML = newCartIconBubble.innerHTML;
        }
        // Update cart footer section
        const cartFooterHTML = doc.querySelector('.footer-offer-box-subscription');
        console.log(cartFooterHTML);
        const cartFooterElement = document.querySelector('.footer-offer-box-subscription');
        if (cartFooterElement && cartFooterHTML) {
          console.log("ui update called")
          cartFooterElement.innerHTML = cartFooterHTML.innerHTML;
        }
    

    console.log("Cart sections updated successfully.");
  } catch (error) {
    console.error("Error updating cart sections:", error);
  }
}





function updateCartUI(cartData) {
  try {
      // Update the cart icon bubble
      const newCartIconBubble = parseHTML(cartData.sections['cart-icon-bubble'], '.cart-count-bubble');
      const currentCartIconBubble = document.querySelector('.cart-count-bubble');
      if (newCartIconBubble && currentCartIconBubble) {
          currentCartIconBubble.innerHTML = newCartIconBubble.innerHTML;
      }

      // Update the cart drawer items
      const newCartItem = parseHTML(cartData.sections['cart-drawer'], '#CartDrawer');

      
      const currentCartItem = document.querySelector('#CartDrawer');
      if (newCartItem && currentCartItem) {
          currentCartItem.innerHTML = newCartItem.innerHTML;
      }



  } catch (error) {
      console.error('Error updating the cart UI:', error);
  }
}

// Helper function to parse HTML and extract a specific element
function parseHTML(htmlString, selector) {
  const doc = new DOMParser().parseFromString(htmlString, 'text/html');
  return doc.querySelector(selector);
}

async function addFreeProductsToCart(freeProducts) {

console.log("freeProducts",freeProducts)

   
      const items = freeProducts
      .map((item) => (
        {
          id: item,
          quantity: 1,
        }
      ) )
       // Flatten the nested arrays

      console.log(items);
     

  const formData = {
    items,
    sections: [
      "cart-drawer",
      "main-cart-items",
      "cart-icon-bubble",
      "cart-live-region-text",
      "cart-footer"
    ]
  };
  
  

  try {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    if (!response.ok) {
      throw new Error('Failed to add free products to cart.');
    }

    const data = await response.json();
    console.log('Free products added:', data);
    updateCartUI(data);
  } catch (error) {
    console.error('Error:', error);
  }
}
